import { useContext } from 'react';
import { TextListContext } from './context.es.js';

const useTextListContext = ()=>{
    const context = useContext(TextListContext);
    return {
        type: context?.type,
        size: context?.size
    };
};

export { useTextListContext };
//# sourceMappingURL=index.es.js.map
